export default "__VITE_ASSET__ryyGzWm8__"